<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm02">
<div class="chapterHead">
<h2 class="chapterTitle0" style="text-indent: 0%;"> </h2></div>
<div class="chapterBody">
<div class="extract">
<p class="extractTextNoIndent" style="text-indent: 0%; margin-left: 5%;"><span class="bold">Concertina</span> <em class="italic">noun, adjective, &amp; verb</em>.</p>
</div>
<div class="extract">
<p class="extractTextNoIndent" style="text-indent: 0%; margin-left: 5%;"><span class="bold">A</span> <em class="italic">noun</em>. 1. A portable free-reed musical instrument consisting of a pair of bellows usu. Polygonal in form, with a set of finger-studs at each end controlling valves which admit wind to the reeds.</p>
<p class="extractTextNoIndent" style="text-indent: 0%; margin-left: 5%;">2. In full <em class="italic">concertina wire</em>. Wire used for entanglements.</p>
<p class="extractTextNoIndent" style="text-indent: 0%; margin-left: 5%;"><span class="bold">B</span> <em class="italic">attrib</em>. Or as <em class="italic">adjective</em>. (Able to be) compressed or closed like a concertina; involving such action.</p>
<p class="extractTextNoIndent" style="text-indent: 0%; margin-left: 5%;"><span class="bold">C</span> <em class="italic">verb trans. &amp; intrans</em>. Shut up like a concertina; compress; collapse; wrinkle.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429983952_fm02.vue?47c973b8